/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Settings_Template_Topic_Drag_StartInputs */



/**
* | output |
* | --- |
* | "Topic {position} picked up." |
*
* @param {Settings_Template_Topic_Drag_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_drag_start = /** @type {((inputs: Settings_Template_Topic_Drag_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Drag_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Onderwerp ${i?.position} opgepakt.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sujet ${i?.position} pris.`)
	return /** @type {LocalizedString} */ (`Topic ${i?.position} picked up.`)
});